// extracted by mini-css-extract-plugin
export default {"base":"ClanWallet_base_fe3af","header":"ClanWallet_header_e8f80","value":"ClanWallet_value_b75e1","tooltip":"ClanWallet_tooltip_ea845","balanceRow":"ClanWallet_balanceRow_b9c49"};